import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Sesión de caja activa — persiste para sobrevivir cierre accidental de la app
export const useSessionStore = create(
  persist(
    (set, get) => ({
      session:    null,   // PosSession document del backend
      terminal:   null,   // PosTerminal document del backend

      openSession: ({ session, terminal }) =>
        set({ session, terminal }),

      closeSession: () =>
        set({ session: null }),

      updateSessionTotals: ({ sales_count, sales_total, expected_cash }) => {
        const s = get().session;
        if (!s) return;
        set({ session: { ...s, sales_count, sales_total, expected_cash: expected_cash ?? s.expected_cash } });
      },

      setTerminal: (terminal) => set({ terminal }),
    }),
    {
      name:       'gc-pos-session',
      partialize: (s) => ({ session: s.session, terminal: s.terminal }),
    }
  )
);
